import React from "react";
import CardItem from "./CardItem";
import "./Cards.css";

function Cards() {
  return (
    <div className="cards">
      <h1>CHOOSE YOUR PHOTOGRAPHY</h1>
      <h2>We offer a variety of photography styles</h2>
      <div className="cards__container">
        <div className="cards__wrapper">
          <ul className="cards__items">
            <CardItem
              src="images/img-17.jpg"
              text="Pre-wedding photography"
              label="Pre-wedding"
              path="/Pe01"
            />
            <CardItem
              src="images/img-14.jpg"
              text="Work photography"
              label="Work"
              path="/Pe02"
            />
            <CardItem
              src="images/img-15.jpg"
              text="Corporate photography"
              label="Corporate"
              path="/Pe03"
            />
          </ul>
          <ul className="cards__items">
            <CardItem
              src="images/img-19.jpg"
              text="Landscape photography"
              label="Landscape"
              path="/Pe06"
            />
          </ul>
          <ul className="cards__items">
            <CardItem
              src="images/img-13.jpg"
              text="Arhitecture/travel photography"
              label="Arhitecture/Travel"
              path="/Pe04"
            />
            <CardItem
              src="images/img-18.jpg"
              text="Team building/seminar photography"
              label="Team Building/Seminar"
              path="/Pe05"
            />
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Cards;
